import IconComponent from '@modules/core/icons/IconComponent'
import React from 'react'
import { withTranslation } from 'react-i18next'

export const BooleanCell = ({ value, t }) => {
  return value ? (
    <IconComponent className="check" text={t('Si')} icon="check" />
  ) : (
    <IconComponent className="cross" text={t('No')} icon="times" />
  )
}
export default withTranslation()(BooleanCell)
